import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  mainHeader: {
    marginTop: theme.spacing(1)
  },
  // formContainer: {
  //   maxWidth: 500
  // },
  textRight: {
    textAlign: 'right'
  },

  title: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.primary,
    fontWeight: 600,
    marginBottom: 8
  },
  subtitle: {
    color: theme.palette.blue_300.main,
    fontWeight: 600,
    fontSize: '1rem',
    marginBottom: 8
  },
  subtitleInstructions: {
    fontWeight: 600,
    fontSize: '1rem',
    marginBottom: 8,
    color: theme.palette.white_100.main
  },
  description: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '1rem'
  },
  descriptionInstructions: {
    color: theme.palette.white_100.main
  },
  descriptionText: {
    marginTop: 8
  },
  descriptionBox: {
    display: 'flex',
    flexDirection: 'column',
    '& span:not(:first-child)': {
      marginLeft: 6
    }
  },
  boxInstructions: {
    backgroundColor: theme.palette.blue_300.main,
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    padding: 16,
    borderRadius: 16
  },
  boxMessage: {
    display: 'flex',
    gap: 8,
    flexWrap: 'nowrap'
  },
  box: {
    padding: 16,
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    borderRadius: 16,
    display: 'flex'
  },
  pre: {
    margin: '2px 0 0 6px'
  },
  hiddenInput: {
    display: 'none'
  },
  uploadContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  fileName: {
    color: theme.palette.type === 'dark'
      ? theme.palette.dark_50.main
      : theme.palette.gray_400.main
  }
}))
